import React from 'react';

import classNames from 'classnames';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getFax, getPrescriptionEmail} from 'selectors/storeInfo';

import s from './sendPrescriptionLater.scss';

type PropsType = {
    className?: string;
    withFax?: boolean;
};

/**
 * Send Prescription Later for checkout page
 * @constructor
 */
export const SendPrescriptionLater: React.FC<PropsType> = ({className, withFax = true}) => {
    const email = useHostSelector(getPrescriptionEmail);
    const fax = useHostSelector(getFax);

    return (
        <section className={classNames(s.sendLater, className)}>
            <p className={s.text}>
                Once you complete checkout,
                <br /> we&apos;ll remind you to send us your prescription.
            </p>
            <p className={s.links}>
                <a className={s.link} href={`mailto:${email}`}>
                    {email}
                </a>{' '}
                or {withFax && `fax `}
                <a className={s.link} href={`tel:${fax}`}>
                    {fax}
                </a>
            </p>
        </section>
    );
};
